import { render } from "./StatsByNetwork.vue?vue&type=template&id=324776dc"
import script from "./StatsByNetwork.vue?vue&type=script&lang=js"
export * from "./StatsByNetwork.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__